import moment from 'moment-timezone';
import i18n from '../i18n';

const languageMapping = {
    ua: 'uk',
};

/**
 * Formats a date object or string to a localized string in the user's timezone
 * @param {Object|string} dateInput - Object with { date, timezone } or ISO 8601 string
 * @param options
 * @returns {string} Formatted date string or 'unknown' if invalid
 */
export const formatDate = (dateInput, options = {}) => {
    const { format = 'LLL', defaultTimezone = 'UTC' } = options;
    const t = i18n.t.bind(i18n);

    if (!dateInput) {
        return t('admin.unknown');
    }

    let lang = i18n.language;
    const intlLanguage = languageMapping[lang] || lang;
    moment.locale(intlLanguage);

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimezone;

    let date;

    if (typeof dateInput === 'string') {
        date = moment.utc(dateInput);
    } else if (dateInput.date && dateInput.timezone) {
        date = moment.utc(dateInput.date).tz(dateInput.timezone);
    } else {
        return t('admin.unknown');
    }

    if (!date.isValid()) {
        return t('admin.unknown');
    }

    return date.tz(userTimezone).format(format);
};